import * as React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { InjectedTranslateProps, translate, Trans } from 'react-i18next';
import { ROLE_FILTER_REMOVED } from '../../../redux/actions/action-types';
import { Role } from '../../../types/roles';
import { withRouter, RouteChildrenProps } from 'react-router-dom';
import { reportCannotDeleteRole } from '../../../redux/actions/bi.actions';

import { MessageBoxFunctionalLayout, Text } from 'wix-style-react';

export interface ICannotRemoveRoleModal extends InjectedTranslateProps, RouteChildrenProps, ConnectedProps<typeof connector> {
  closeModal(): void;
  onCancel(): void;
  numOfContributors: number;
  roleId: string;
  roleName: string;
  onOk: () => void;
  roles: Role[];
}

export class CannotRemoveRoleComponent extends React.PureComponent<ICannotRemoveRoleModal> {

  onOk = () => {
    const { onViewContributorsClicked, closeModal, onOk, roleId, roles, history } = this.props;
    onViewContributorsClicked(roles.filter(role => role.id !== roleId).map(r => r.id), history, roleId);
    closeModal();
    if (onOk) { onOk(); }
  }

  render() {
    const { roleName, t, numOfContributors, onCancel } = this.props;

    return (
      <MessageBoxFunctionalLayout
        dataHook="cannot-remove-role-layout"
        title={t('app.cannotRemoveRole.title')}
        confirmText={t('app.cannotRemoveRole.viewContributors')}
        cancelText={t('app.cannotRemoveRole.cancelCTA')}
        onCancel={onCancel}
        onClose={onCancel}
        onOk={this.onOk}
        theme="blue"
        width="540px"
      >
        <Trans i18nKey="app.cannotRemoveRole.description" count={numOfContributors} values={{ roleName }}>
          <Text weight="normal">0</Text>
          <Text>1</Text>
          <Text weight="normal">2</Text>
          <Text>3</Text>
        </Trans>
      </MessageBoxFunctionalLayout>
    );
  }
}

const mapDispatchToProps = (dispatch, props) => ({
  onViewContributorsClicked: (rolesTofilterOut: string[], history, roleId: string) => {
      dispatch({ type: ROLE_FILTER_REMOVED, value: rolesTofilterOut });
      history.push('/');
      dispatch(reportCannotDeleteRole(roleId, 'view teammates'));
  },
  onCancel: () => {
    props.closeModal();
    dispatch(reportCannotDeleteRole(props.roleId, 'cancel'));
  },
});

const connector = connect(null, mapDispatchToProps);
export const CannotRemoveRole = withRouter(connector(translate()(CannotRemoveRoleComponent)));
